import {
  TransactionGroupRange,
  TransactionTimeGroupBy as ResourceConsumptionTimeGroupBy
} from '@zerops/models/transaction-debit';
import { HashMap } from '@zerops/zef/core';

export class ResourceConsumptionBaseState {
  data: HashMap<any>;
  trackedItems: any[];

  constructor() {
    this.data = {};
    this.trackedItems = [];
  }
}

export interface ResourceConsumptionGroupItem {
  amount: number;
  from: string;
  metricId: string;
  projectId: string;
  projectName: string;
}

export interface ResourceConsumptionGroupRequestPayload {
  groupRange: TransactionGroupRange;
  groupBy: 'projectId'; // Resource consumption only supports projectId grouping
  metricId?: string;
  projectId?: string;
  isPeriodUpdate?: boolean;
}

export interface ResourceConsumptionGroupUpdateSuccessPayload {
  items: ResourceConsumptionGroupItem[];
  limit: number;
  timeGroupBy: ResourceConsumptionTimeGroupBy;
  groupBy: 'projectId';
  metricId?: string;
  projectId?: string;
  key?: string;
  from?: string | Date;
  till?: string | Date;
}

// Internal API request structure
export interface ResourceConsumptionGroupSearchRequest {
  search: Array<{
    name: 'clientId' | 'projectId';
    operator: 'eq' | 'ne' | 'in' | 'nin';
    value: string;
  }>;
  receiverId?: string;
  subscriptionName?: string;
  groupBy: 'projectId';
  timeGroupBy: ResourceConsumptionTimeGroupBy;
  timeZone: string;
  limit?: number;
  from?: string | Date;
  till?: string | Date;
  metricId?: string;
}

export interface ResourceConsumptionGroupSearchResponse {
  items: ResourceConsumptionGroupItem[];
}